module.exports = __webpack_public_path__ + "static/img/xhs-code.ec58794.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/xhs-code.jpg
// module id = eGn6
// module chunks = 0